import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { useLang } from "@/i18n";

export const MobileCTA = () => {
  const { t } = useLang();
  return (
    <div data-testid="mobile-sticky-cta" className="fixed inset-x-0 bottom-0 z-40 border-t border-amber-900/10 bg-sand/90 backdrop-blur-md md:hidden">
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          data-testid="mobile-cta-call"
          href="tel:+393386264991"
          className="flex items-center justify-center gap-2 rounded-full border border-mare/20 bg-white py-3 text-sm font-bold text-mare"
        >
          <Phone size={16} /> {t.contact.phone}
        </a>
        <Link
          data-testid="mobile-cta-book"
          to="/prenota"
          className="flex items-center justify-center rounded-full bg-terracotta py-3 text-sm font-bold text-sand shadow-lg shadow-terracotta/25"
        >
          {t.hero.cta2}
        </Link>
      </div>
    </div>
  );
};
